import React from 'react'
import { AppBar, FlatButton, Drawer, MenuItem } from "material-ui";
import { connect } from "react-redux";
import { setLogout } from "../Actions/auth";
import { addMessage } from "../Actions/messages";

class AdminNavigation extends React.Component {
    constructor() {
        super();
        this.state = {
            showMenuIconButton: false,
            showDrawer: false
        };
        this.logOut = this.logOut.bind(this);
    }
    componentWillMount = () => {
        if (window.innerWidth <= 800) this.setState({ showMenuIconButton: true });
    }
    logOut() {
        this.props.setLogout();
        this.props.addMessage("Logout successfully!", "success");
        this.props.history.push("/login");
    }
    navigateToSpecificRoute = (route, changeState) => {
        this.props.history.push(route);
        if (changeState) this.setState({ showDrawer: false });
    }
    render() {
        return (
            <div>
                <AppBar
                    title={<span style={styles.title}>Admin Dashboard</span>}
                    onTitleClick={_ => { this.props.history.push("/admin"); }}
                    iconElementRight={!this.state.showMenuIconButton ? <div style={{ marginTop: 5 }}><FlatButton label="Projects" onClick={_ => { this.navigateToSpecificRoute("/admin/projects"); }} style={styles.navigationBTNS} /><FlatButton label="Message" onClick={_ => { this.navigateToSpecificRoute("/admin/messages"); }} style={styles.navigationBTNS} /><FlatButton label="LogOut" style={styles.navigationBTNS} onClick={this.logOut} /></div> : <div></div>}
                    style={styles.nav}
                    showMenuIconButton={this.state.showMenuIconButton}
                    onLeftIconButtonClick={_ => { this.setState({ showDrawer: true }); }}
                />
                <Drawer
                    docked={false}
                    width={250}
                    open={this.state.showDrawer}
                    onRequestChange={(showDrawer) => this.setState({ showDrawer })}
                >
                    <div style={styles.AdminSignShower}>A</div>
                    <MenuItem onClick={_ => { this.navigateToSpecificRoute("/admin/projects", true); }}>Projects</MenuItem>
                    <MenuItem onClick={_ => { this.navigateToSpecificRoute("/admin/messages", true); }}>Messages</MenuItem>
                    <MenuItem onClick={this.logOut}>LogOut</MenuItem>
                </Drawer>
            </div>
        );
    }
}

const styles = {
    nav: {
        backgroundColor: "#2c3e50",
    },
    title: {
        cursor: 'pointer',
    },
    navigationBTNS: {
        color: "#fff",
        paddingTop: 3,
        paddingBottom: 3
    },
    AdminSignShower: {
        width: 80,
        height: 80,
        borderRadius: 80,
        border: "4px solid #2c3e50",
        color: "#2c3e50",
        fontWeight: "bold",
        textAlign: "center",
        fontSize: 40,
        paddingTop: 6,
        margin: "auto",
        marginTop: 40,
        marginBottom: 20,
    },
};

export default connect(null, { setLogout, addMessage })(AdminNavigation);


// WEBPACK FOOTER //
// ./src/Components/adminNavigation.jsx